import * as React from "react";
const Loader = (props) => /* @__PURE__ */ React.createElement("div", {
  className: "loader"
}, /* @__PURE__ */ React.createElement("svg", {
  width: 64,
  height: 64,
  viewBox: "0 0 28 31",
  fill: "#ddd",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "m1.8306 5.9835 3.6876 6.4789-5.5183 9.5555h6.5851l5.4788-9.5555-3.6876-6.4789 "
}), /* @__PURE__ */ React.createElement("path", {
  d: "m21.4280 0-10.6415 18.6417 6.8617 12.3582h6.6773l-6.9802-12.3582 10.6547-18.6417z"
})));
export {
  Loader
};
